<template>
  <b-form-group :label="properties.label">
    <div class="d-flex align-items-center">
      <div class="border rounded value-container w-100 mr-2">{{showCondition}}</div>
      <i @click="showEditor" class="fas fa-edit text-primary hover-pointer"></i>
    </div>
    <b-modal
      centered
      no-close-on-backdrop
      title="Component rules"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="saveCondition"
      v-model="showingEditor"
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Close
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <div>
        <div class="d-flex align-items-center">
            <div class="d-flex flex-column" style="min-width: 200px; max-width: 200px;">
                <small>Auto populate this field:</small>
                <small>(Field from current form)</small>
            </div>
            <div class="mx-3"></div>
            <div class="d-flex flex-column">
                <small>Using the value from this field:</small>
                <small>(Field from selected document)</small>
            </div>
        </div>
        <div v-for="(statement, statementIndex) in conditionStatements"  :key="statementIndex">
          <div class="d-flex align-items-center mt-3">
            <b-form-select v-model="statement.componentId" :options="componentOptions" size="sm" style="min-width: 200px; max-width: 200px;"></b-form-select>
            <div class="mx-3">=</div>

            <div v-if="statement.componentId" class="w-100">
              <b-form-select v-model="statement.valueToCompare" :options="selectedFormComponentOptions" size="sm"></b-form-select>
            </div>
            
            <i class="fas fa-trash-alt ml-3 text-danger hover-pointer" @click="removeStatement(statementIndex)"></i>
            <i class="fas fa-plus ml-3 text-primary hover-pointer" @click="addStatement(statementIndex)"></i>
          </div>
        </div>
        <i v-if="conditionStatements.length == 0" class="fas fa-plus ml-3 text-primary hover-pointer" @click="addStatement(0)"></i>
      </div>
    </b-modal>
  </b-form-group>
</template>

<script>
import { getFormBuilderComponents } from "../../../helpers/formBuilder"
import { mapState } from "vuex"
var esprima = require('esprima');
import collectionServer from "../../../server/collection";
import formServer from "../../../server/form";

export default {
  name: "AutopopulationPropertyType",
  props: ["properties", "property", "value", "element", "formId"],
  data() {
    return {
      showingEditor: false,
      conditionStatements: [],
      components: [],
      selectedFormcomponents: [],
      computedComponentOptions: {}
    }
  },
  async mounted() {
    this.conditionStatements = await this.valueToConditionStatements();
  },
  methods: {
    async showEditor() {
      this.fetchFormBuilderComponents();
      this.fetchFormPickerComponents();
      await this.computeComponentOptions();
      this.showingEditor = true;
    },
    async computeComponentOptions() {
      let computedComponentOptions= {};
      for (let index = 0; index < this.components.length; index++) {
        const component = this.components[index];
        if(component.id.startsWith("Dropdown") || component.id.startsWith("SingleChoice") || component.id.startsWith("MultipleChoice")) {
          computedComponentOptions[component.id] = await this.getOptions(component.properties.options);
        }
        if(component.id.startsWith("AssessmentQuestion")) {
          computedComponentOptions[component.id] = await this.getOptions(component.properties.answers);
        }
      }
      this.computedComponentOptions = computedComponentOptions;
    },
    saveCondition() {
      if(this.conditionStatements.length == 0) {
        this.propertyValue = "";
        return;
      }
      let propertyValue = "() => {"
      for (let index = 0; index < this.conditionStatements.length; index++) {
        const statement = this.conditionStatements[index];
        if (statement.componentId && statement.valueToCompare) {
            propertyValue += `setComponentValue('${statement.componentId}', components.${this.element.id}.Value.results.${statement.valueToCompare});`
        }
      }
      propertyValue += "}"
      this.propertyValue = propertyValue;
    },
    removeStatement(statementIndex) {
      let newConditionStatements = [...this.conditionStatements]
      newConditionStatements.splice(statementIndex,1);
      this.conditionStatements = newConditionStatements;
    },
    addStatement(statementIndex) {
      let newConditionStatements = [...this.conditionStatements]
      let newStatement = {
        componentId: null,
        valueToCompare: "",
      };    
      
      if(statementIndex + 1 == newConditionStatements.length) {
        newConditionStatements.push(newStatement)
      }
      else {
        newConditionStatements.splice(statementIndex + 1, 0, newStatement)
      }
      
      this.conditionStatements = newConditionStatements;
    },
    fetchFormBuilderComponents() {
      let components = getFormBuilderComponents(this.currentForm.json);
      this.components = components;
    },
    async fetchFormPickerComponents() {
      let selectedForm = await formServer.get(this.element.properties.formId);
      let selectedFormcomponents = getFormBuilderComponents(selectedForm.current.content);
      this.selectedFormcomponents = selectedFormcomponents;
    },
    valueToConditionStatements() {
      let conditionStatements = [];
      try {
        let tokens = esprima.tokenize(this.propertyValue)
        for (let index = 0; index < tokens.length; index++) {
          const token = tokens[index];
          if(token.type == "String") {
            let componentId = token.value.substr(1, token.value.length - 2);
            let valueToCompare = tokens[index + 10].value;
            
            conditionStatements.push(
              {
                componentId: componentId,
                valueToCompare: valueToCompare,
              } 
            );
            index += 10;
          }
        }
    }
     catch (error) {
        console.log(error)
      }
      if(conditionStatements.length == 0) {
        conditionStatements.push({
          componentId: null,
          valueToCompare: "",
        });
      } 
      return conditionStatements
    },
    async getOptions(options) {
      if (typeof options == "string") {
        let re = /\{\{collections.(?:(?!\}\}).)*\}\}/g;
        const matches = [...options.matchAll(re)];
        if (
          matches.length == 1 &&
          options.startsWith("{{") &&
          options.endsWith("}}")
        ) {
          const collections = await collectionServer.query();
          const collection = collections.find(
            c =>
              c.name ==
              options.slice(
                14,
                options.length - 2
              )
          );
          return collection.data.items;
        } else return options;
      } else return options;
    },
  },
  computed: {
    ...mapState("formBuilder", {
      forms: state => state.form
    }),
    currentForm() {
      return this.forms[this.formId]
    },
    propertyValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        let newPropertyValue = newValue;
        if(newValue && this.properties.updateValueMiddleware) {
          newPropertyValue = this.properties.updateValueMiddleware(newPropertyValue);
        }
        this.$emit("update-value", this.property, newPropertyValue, false);
      }
    },
    showCondition() {
      let conditionText = "";
      if (this.conditionStatements) {
        this.conditionStatements.forEach(condition => {
            if (condition.componentId && condition.valueToCompare) {
                conditionText+=`${condition.componentId} = selected.${condition.valueToCompare}`;
            }
        });
      }
     
      return conditionText ? conditionText : "No condition";
    },
    componentOptions() {
      return this.components.filter(c => 
          c.id.startsWith("TextInput") ||
          c.id.startsWith("Boolean") ||
          c.id.startsWith("EmailInput") ||
          c.id.startsWith("PhoneInput") ||
          c.id.startsWith("NumberInput") ||
          c.id.startsWith("PasswordInput") ||
          c.id.startsWith("Dropdown") ||
          c.id.startsWith("DatePicker") ||
          c.id.startsWith("TimePicker") ||
          c.id.startsWith("Textarea") ||
          c.id.startsWith("SingleChoice") ||
          c.id.startsWith("MultipleChoice") ||
          c.id.startsWith("AssessmentQuestion")
        ).map(c => ({
        value: c.id,
        text: c.id
      }))
    },
    selectedFormComponentOptions() {
      return this.selectedFormcomponents.filter(c => 
          c.id.startsWith("TextInput") ||
          c.id.startsWith("Boolean") ||
          c.id.startsWith("EmailInput") ||
          c.id.startsWith("PhoneInput") ||
          c.id.startsWith("NumberInput") ||
          c.id.startsWith("PasswordInput") ||
          c.id.startsWith("Dropdown") ||
          c.id.startsWith("DatePicker") ||
          c.id.startsWith("TimePicker") ||
          c.id.startsWith("Textarea") ||
          c.id.startsWith("SingleChoice") ||
          c.id.startsWith("MultipleChoice") ||
          c.id.startsWith("AssessmentQuestion")
        ).map(c => ({
        value: c.id,
        text: c.id
      }))
    }
  }
};
</script>

<style>
.lower-font-size {
  font-size: 14px !important;
}
.lower-font-size .custom-control-label {
  padding-top: 2px;
}
.value-container {
  height: 31px;
  font-size: 14px; 
  padding-top: 3px; 
  padding-left: 6px; 
  padding-right: 6px; 
  white-space: nowrap; 
  overflow-x: hidden;
  text-overflow: ellipsis;
}
</style>
